import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import { isWeaponType } from '@/types/lootTypes';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import LootWeaponsProperties from './LootWeaponsProperties.vue';
import BackButton from '@/components/BackButton.vue';
const equipmentModule = namespace('equipment');
let LootWeapons = class LootWeapons extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Weapons';
    }
    created() {
        this.fetchEquipment();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.equipment)
            .filter(isWeaponType)
            .map(equipment => ({
            ...equipment,
            id: equipment.name,
            isExpandable: true
        })).value();
    }
    filterProperties(propertiesMap, filterValue) {
        var x = Object.keys(propertiesMap);
        var y = _.intersection(x, filterValue);
        return y.length;
    }
    get properties() {
        return _(this.items).map(({ propertiesMap }) => (Object.keys(propertiesMap))).flattenDeep().compact().sortBy().uniq().value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Type',
                value: 'weaponClassification',
                render: _.startCase,
                filterChoices: ['Simple Blaster', 'Martial Blaster', 'Simple Lightweapon', 'Martial Lightweapon',
                    'Simple Vibroweapon', 'Martial Vibroweapon', 'Exotic Blaster', 'Exotic Lightweapon', 'Exotic Vibroweapon'],
                filterFunction: ({ weaponClassification }, filterValue) => _.startCase(weaponClassification) === filterValue
            },
            {
                text: 'Property',
                value: 'propertiesMap',
                isMultiSelect: true,
                render: (propertiesMap) => Object.values(propertiesMap).map((property) => _.upperFirst(property)).join(', '),
                filterChoices: this.properties,
                filterFunction: ({ propertiesMap }, filterValue) => this.filterProperties(propertiesMap, filterValue)
            },
            { text: 'Cost', value: 'cost' },
            { text: 'Weight', value: 'weight' },
            { text: 'Damage', value: 'damageNumberOfDice', render: this.weaponDamage },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
    weaponDamage(field, fields) {
        return fields.damageNumberOfDice ? `${fields.damageNumberOfDice}d${fields.damageDieType} ${fields.damageType}` : 'Special';
    }
};
__decorate([
    equipmentModule.State
], LootWeapons.prototype, "equipment", void 0);
__decorate([
    equipmentModule.Action
], LootWeapons.prototype, "fetchEquipment", void 0);
LootWeapons = __decorate([
    Component({
        components: {
            SearchTable,
            VueMarkdown,
            LootWeaponsProperties,
            BackButton
        }
    })
], LootWeapons);
export default LootWeapons;
